<template>
  <div>
    <h1 class="text-xs-center">Business List</h1>
    <v-card>
      <businesslist />
    </v-card>
  </div>
</template>

<script>
import businesslist from "@/components/back-office/Business/Business-table.vue";
import { mapState } from "vuex";
export default {
  components: {
    businesslist,
  },
};
</script>
